<template>
  <v-data-table
    class="py-4 nowrap"
    v-model="selected"
    :headers="headers"
    :items="productList"
    :single-select="singleSelect"
    item-key="name"
  >
    <template v-slot:top>
      <autocomplete-product
        v-model="newProduct"
        item-text="name"
        label="Sản Phẩm"
        @change="addNewProduct"
      ></autocomplete-product>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon  medium @click="deleteProduct(item)">delete</v-icon>
    </template>
    <template v-slot:item.price="{ item }">
      <div class="text-right body-2 font-weight-black">{{item.price * item.quantity | formatMoney}}</div>
    </template>
    <template v-slot:item.quantity="props">
      <v-edit-dialog :return-value.sync="props.item.quantity" large persistent>
        <div>{{ props.item.quantity }}</div>
        <template v-slot:input>
          <div class="title">Update Iron</div>
        </template>
        <template v-slot:input>
          <v-text-field
            v-model="props.item.quantity"
            label="Edit"
            single-line
            type="number"
            autofocus
          ></v-text-field>
        </template>
      </v-edit-dialog>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import utils from '@/plugins/utils.js'
import AutocompleteProduct from '@/components/basic/input/AutocompleteProduct.vue'
export default {
  components: { AutocompleteProduct },
  data () {
    return {
      loading: false,
      singleSelect: false,
      selected: [],
      newProduct: null,
      headers: [
        { text: 'Mã', align: 'start', sortable: false, value: 'code' },
        { text: 'Sản Phẩm', value: 'title' },
        { text: 'Số Lượng', value: 'quantity' },
        { text: 'Đơn Giá', value: 'price' },
        { text: 'Xoá', value: 'actions' }
      ],
      products: []
    }
  },
  created () {},
  computed: {
    ...mapGetters('app', ['department']),
    ...mapGetters('auth', ['profile']),
    ...mapState('auth', ['students']),
    productList () {
      return this.products.map(p => ({ ...p, quantity: p.quantity || 1 }))
    }
  },
  methods: {
    ...mapActions('sale', ['createBill', 'createLead']),
    addNewProduct (product) {
      this.products.push(product)
      this.newProduct = null
      this.$emit('update:products', this.productList)
    },
    deleteProduct (product) {
      this.products = this.products.filter(p => p.id !== product.id)
      this.$emit('update:products', this.productList)
    }
  },
  filters: {
    formatMoney (data) {
      return utils.formatMoney(data)
    }
  }
}
</script>
